module.exports = __webpack_public_path__ + "img/daniele_.1bcf60de.jpg";